import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Needs from "@/components/site/Needs";
import Areas from "@/components/site/Areas";
import Programs from "@/components/site/Programs";
import OneOnOne from "@/components/site/OneOnOne";
import GroupCircles from "@/components/site/GroupCircles";
import AncientWisdom from "@/components/site/AncientWisdom";
import Modalities from "@/components/site/Modalities";
import Comparison from "@/components/site/Comparison";
import Steps from "@/components/site/Steps";
import About from "@/components/site/About";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import BookForm from "@/components/site/BookForm";
import FinalCTA from "@/components/site/FinalCTA";
import BookingModal from "@/components/site/BookingModal";

export default function Landing() {
  const [data, setData] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [activeProgram, setActiveProgram] = useState(null);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/content/landing"); setData(data); } catch (_e) { /* silent */ }
    })();
  }, []);

  const openModal = (program) => { setActiveProgram(program || null); setModalOpen(true); };
  const scrollToBook = () => document.getElementById("book")?.scrollIntoView({ behavior: "smooth" });

  if (!data) return <div className="min-h-[60vh] grid place-items-center text-sm" style={{ color: "var(--ev-muted)" }}>Preparing your space…</div>;

  return (
    <>
      <Hero brand={data.brand} stats={data.stats} onBook={scrollToBook} />
      <Marquee items={data.marquee} />
      <Needs needs={data.needs} onBook={scrollToBook} />
      <Areas areas={data.areas} />
      <Programs programs={data.programs} onBook={openModal} />
      <OneOnOne bullets={data.one_on_one?.bullets || []} image={data.one_on_one?.image} onBook={scrollToBook} />
      <GroupCircles bullets={data.group_circles?.bullets || []} image={data.group_circles?.image} onBook={scrollToBook} />
      <AncientWisdom copy={data.ancient_wisdom?.copy} onBook={scrollToBook} />
      <Modalities items={data.modalities} />
      <Comparison rows={data.comparison} />
      <Steps steps={data.steps} onBook={scrollToBook} />
      <About brand={data.brand} stats={data.stats} about={data.about} onBook={scrollToBook} />
      <Testimonials items={data.testimonials} />
      <FAQ items={data.faq} />
      <BookForm areaOptions={data.area_options || []} />
      <FinalCTA onBook={scrollToBook} />
      <BookingModal open={modalOpen} onOpenChange={setModalOpen} program={activeProgram} />
    </>
  );
}
